/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { GridToolbarQuickFilter } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDebouncedChange } from "./hooks/use-debounced-change";

/**
 * @type {import('react').FC<SearchToolBarProps>}
 */
export const SearchToolBar = (props) => {

    const { t } = useTranslation();
    const defaultPlaceholder = t("commons.searchByTitle");

    const { 
        onChange,
        wait = 500,
        placeholder = defaultPlaceholder
    } = props;

    const [search, setSearch] = useState("");
    const debouncedChange = useDebouncedChange(onChange, wait);

    // unfortunately have to dynamically set onChange since an undefined value
    // will still remove the built-in filter
    const filterProps = onChange ? {
        value: search,
        onChange (event) {
            setSearch(event.target.value);
        }
    } : {};

    useEffect(() => {
        debouncedChange(search);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    return (
        <div className='form-search-tool-bar'>
            {/* <GridToolbarFilterButton
               componentsProps={{
                   button: {
                       startIcon: <FilterAltIcon />,
                   },
               }}
               className='filter-button'
            /> */}

            <GridToolbarQuickFilter
                variant='outlined'
                placeholder={placeholder}
                className='form-search-text-field'
                debounceMs={wait}
                {...filterProps}
            />
        </div>
    );
};


/**
 * @typedef {object} SearchToolBarProps
 * @property {(search: string) => void=} onChange
 * @property {number=} wait
 * @property {string=} placeholder
 */
